// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vital_icon[data-v-fbc81884]{height:60px!important;width:60px}", ""]);
// Exports
module.exports = exports;
